import React from "react";

interface TabItemProps {
  icon?: React.ReactNode;
  title: string;
  active: boolean;
  onClick?: () => void;
}

const TabItem: React.FC<TabItemProps> = ({ title, icon, active, onClick }) => {
  return (
    <button
      onClick={onClick}
      className={`px-6 py-2 bg-gray-200  text-primary text-base flex-1 flex justify-center items-center gap-2 ${
        active === true ? "bg-gray-300" : ""
      }`}
    >
      <span>{icon}</span>
      <span className="hidden md:block font-normal">{title}</span>
    </button>
  );
};

export default TabItem;
